/* NewMarketPitch article enhancements (v1, 20 Oct 2026).
   Runs on blog articles only (.nmp-art). Turns the raw article HTML into the validated layout:
   meta line, contents sidebar, signature, big tables (valuation, top funding, deals, revenue),
   small-table details, funding-news cards. Unknown values are left as plain text: nothing breaks. */
(function () {
  'use strict';
  var art = document.querySelector('.nmp-art');
  if (!art) return;
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('nmp-art-config') || {}).textContent || '{}'); } catch (e) {}
  var LABELS = {};
  var lab = CFG.labels;
  if (typeof lab === 'string') { try { lab = JSON.parse(lab); } catch (e) { lab = []; } }
  if (!Array.isArray(lab)) lab = [];
  lab.forEach(function (x) { if (x && x.h2) LABELS[norm(x.h2)] = x.label; });

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function txt(el) { return norm(el ? el.textContent : ''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function money(s) {
    var re = /(\d+(?:[.,]\d+)?)\s*([BMK])\b/g, m, v = [];
    s = (s || '').replace(/,/g, '');
    while ((m = re.exec(s))) v.push(parseFloat(m[1]) * { B: 1e9, M: 1e6, K: 1e3 }[m[2]]);
    if (!v.length) return null;
    v = v.slice(0, 2);
    return v.reduce(function (a, b) { return a + b; }, 0) / v.length;
  }
  function normDate(s) {
    var m = /([A-Z][a-z]+)\s+(\d{1,2}),\s*(\d{4})/.exec(s);
    if (m && MONTHS.indexOf(m[1]) > -1) return +m[2] + ' ' + m[1] + ' ' + m[3];
    m = /(\d{1,2})\s+([A-Z][a-z]+)\s+(\d{4})/.exec(s);
    if (m) return +m[1] + ' ' + m[2] + ' ' + m[3];
    return norm(s);
  }
  function shortDate(s) {
    var m = /([A-Z][a-z]+)\s+(\d{4})/.exec(s);
    if (m && MONTHS.indexOf(m[1]) > -1 && !/\d{1,2}\s+[A-Z]/.test(s)) return m[1].slice(0, 3) + ' ' + m[2];
    m = /(\d{1,2})\s+([A-Z][a-z]+)\s+(\d{4})/.exec(s);
    if (m) return +m[1] + ' ' + m[2].slice(0, 3);
    m = /([A-Z][a-z]+)\s+(\d{1,2}),\s*(\d{4})/.exec(s);
    if (m) return +m[2] + ' ' + m[1].slice(0, 3);
    return s;
  }
  function sentence(s) {
    s = norm(s); if (!s) return s;
    var out = s[0] + s.slice(1).toLowerCase();
    ['IPO', 'ARR', 'AI', 'SPAC', 'M&A'].forEach(function (a) { out = out.replace(new RegExp('\\b' + a.toLowerCase().replace('&', '&') + '\\b', 'g'), a); });
    return out;
  }
  // tolerant vocabularies
  function confClass(v) { v = v.toLowerCase(); if (/full|^high|very high/.test(v)) return 'k-cf'; if (/strong|medium/.test(v)) return 'k-cs'; if (/partial/.test(v)) return 'k-cp'; if (/low/.test(v)) return 'k-cl'; return ''; }
  function stageLevel(v) { v = v.toLowerCase(); if (/pre-seed|seed|angel|grant/.test(v)) return 1; if (/series [ab]\b/.test(v)) return 2; if (/series [c-z]|series d\+|growth|late|private equity/.test(v)) return 3; return 0; }
  function freshClass(v) { v = v.toLowerCase(); if (/very fresh|^fresh/.test(v)) return 'fr-g'; if (/aging|ageing/.test(v)) return 'fr-a'; if (/historical|stale|old/.test(v)) return 'fr-o'; return ''; }
  function verdictClass(v) { v = v.toLowerCase().trim(); if (/^yes/.test(v)) return 'vd-y'; if (/^no\b/.test(v) && v.indexOf('not enough') < 0) return 'vd-n'; if (/mixed|partly/.test(v)) return 'vd-m'; return ''; }
  function chip(cls, label) { return cls ? '<span class="nmp-chip ' + cls + '"><i aria-hidden="true"></i>' + esc(label) + '</span>' : esc(label); }
  function bar(v, max) { if (!v || !max) return ''; return '<span class="nmp-vb"><span style="width:' + Math.max(2, Math.round(100 * v / max)) + '%"></span></span>'; }
  function tierOf(v, cuts) { if (v == null) return 'Undisclosed'; for (var i = 0; i < cuts.length; i++) if (v >= cuts[i][0]) return cuts[i][1]; return cuts[cuts.length - 1][1]; }
  function rows(table) { return Array.prototype.slice.call(table.querySelectorAll('tbody tr, tr')).filter(function (r) { return r.querySelector('td'); }); }
  function heads(table) { return Array.prototype.map.call(table.querySelectorAll('th'), txt); }
  function cellTexts(tr) { return Array.prototype.map.call(tr.querySelectorAll('td'), txt); }

  /* ---------- big table shell: search (21), show-more (28), tiers (16), bars (13) ---------- */
  var btCount = 0;
  function bigTable(label, metaLeft, theadHtml, bodyHtml, total, noun) {
    var id = 'nmp-bt-' + (++btCount);
    var more = total > 20 ? '<div class="nmp-bt-more"><span class="nmp-bt-count">Showing 20 of ' + total + ' ' + noun + '</span><button type="button" class="nmp-bt-btn" aria-expanded="false"><span>View all ' + total + ' ' + noun + '</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button></div>' : '';
    var box = h('div', 'nmp-bt');
    box.id = id;
    box.innerHTML = '<div class="nmp-bt-meta"><span>' + esc(metaLeft) + '</span><span>' + esc(CFG.updated || '') + '</span></div>' +
      '<label class="nmp-flt" for="' + id + '-q"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg><input id="' + id + '-q" type="search" placeholder="Find a ' + noun.replace(/s$/, '').replace(/ie$/, 'y') + '" autocomplete="off"></label>' +
      '<div class="nmp-bt-scroll" tabindex="0" role="region" aria-label="' + esc(label) + '"><table class="nmp-bt-table"><thead><tr>' + theadHtml + '</tr></thead><tbody>' + bodyHtml + '</tbody></table></div>' +
      '<p class="nmp-bt-none" hidden>No ' + noun + ' match this search.</p>' + more;
    var btn = box.querySelector('.nmp-bt-btn'), count = box.querySelector('.nmp-bt-count');
    if (btn) btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.firstChild.textContent = open ? 'Show top 20 only' : 'View all ' + total + ' ' + noun;
      count.textContent = open ? 'Showing all ' + total + ' ' + noun : 'Showing 20 of ' + total + ' ' + noun;
      if (!open) box.scrollIntoView({ block: 'start' });
    });
    var q = box.querySelector('input'), none = box.querySelector('.nmp-bt-none');
    q.addEventListener('input', function () {
      var v = q.value.trim().toLowerCase(), shown = 0;
      box.classList.toggle('is-searching', !!v);
      box.querySelectorAll('tr.nmp-row').forEach(function (r) { var hit = !v || r.textContent.toLowerCase().indexOf(v) > -1; r.hidden = !hit; if (hit) shown++; });
      none.hidden = !v || shown > 0;
    });
    return box;
  }
  function tieredRows(list, valueOf, cuts, rowHtml, cols) {
    var out = [], cur = null;
    list.forEach(function (it, i) {
      var t = cuts ? tierOf(valueOf(it), cuts) : null, more = i >= 20 ? ' is-more' : '';
      if (cuts && t !== cur) { out.push('<tr class="nmp-tier' + more + '"><td colspan="' + cols + '">' + esc(t) + '</td></tr>'); cur = t; }
      out.push('<tr class="nmp-row' + more + '">' + rowHtml(it) + '</tr>');
    });
    return out.join('');
  }

  function enhanceValuation(wrap, table) {
    var list = rows(table).map(function (r) { var c = cellTexts(r); return { rank: c[0], name: c[1], what: c[2], val: c[3], conf: (c[4] || '').replace(' Confidence', ''), vtype: c[5], ev: c[6] || '', fund: c[7] || '' }; });
    if (!list.length) return;
    var max = Math.max.apply(null, list.map(function (x) { return money(x.val) || 0; }));
    var body = tieredRows(list, function (x) { return money(x.val); }, [[10e9, '$10B and above'], [5e9, '$5B to $10B'], [1e9, '$1B to $5B'], [0, 'Below $1B']], function (x) {
      return '<td class="c-rank">' + esc(x.rank) + '</td><th scope="row" class="c-name"><span class="nm">' + esc(x.name) + '</span><span class="ds">' + esc(x.what) + '</span></th>' +
        '<td class="c-num"><span class="v">' + esc(x.val) + '</span>' + bar(money(x.val), max) + '</td><td>' + chip(confClass(x.conf), x.conf) + '</td>' +
        '<td class="c-basis">' + esc(sentence(x.vtype)) + '<span class="ev ev-' + esc(x.ev.toLowerCase()) + '">' + esc(x.ev) + '</span></td><td class="c-num">' + esc(x.fund) + '</td>';
    }, 6);
    var th = '<th scope="col" class="c-rank">#</th><th scope="col" class="c-name">Startup</th><th scope="col" class="c-num">Valuation</th><th scope="col">Confidence</th><th scope="col">Valuation basis</th><th scope="col" class="c-num">Total funding</th>';
    wrap.replaceWith(bigTable('Startups ranked by valuation', list.length + ' startups ranked by current valuation', th, body, list.length, 'startups'));
  }
  function enhanceTopFunding(wrap, table) {
    var hd = heads(table), ix = {}; hd.forEach(function (x, i) { ix[x] = i; });
    var g = function (c, k) { return ix[k] != null ? (c[ix[k]] || '') : ''; };
    var list = rows(table).map(cellTexts).filter(function (c) { return c.length >= 5; });
    if (!list.length) return;
    var max = Math.max.apply(null, list.map(function (c) { return money(g(c, 'Total Raised ($)')) || 0; }));
    var year = new Date().getFullYear();
    var body = tieredRows(list, function (c) { return money(g(c, 'Total Raised ($)')); }, [[1e9, '$1B and above'], [500e6, '$500M to $1B'], [100e6, '$100M to $500M'], [0, 'Below $100M']], function (c) {
      var lr = g(c, 'Last Round Date'), y = /(\d{4})/.exec(lr), old = y && year - +y[1] >= 2 ? ' und' : '';
      var st = g(c, 'Current Stage'), sc = { shutdown: 'vd-n', acquired: 'vd-m', ipo: 'vd-y' }[st.toLowerCase()];
      return '<td class="c-rank">' + esc(g(c, '#')) + '</td><th scope="row" class="c-name"><span class="nm">' + esc(g(c, 'Startup')) + '</span><span class="ds">' + esc(g(c, 'What They Do')) + '</span></th>' +
        '<td class="c-num"><span class="v">' + esc(g(c, 'Total Raised ($)')) + '</span>' + bar(money(g(c, 'Total Raised ($)')), max) + '</td>' +
        '<td><span class="lr' + old + '">' + esc(shortDate(lr)) + '</span><span class="ds">' + esc(g(c, 'Last Round Amount ($)')) + ' · ' + esc(sentence(g(c, 'Last Round Type'))) + '</span></td>' +
        '<td>' + (sc ? '<span class="nmp-vd ' + sc + '">' + esc(st) + '</span>' : esc(st)) + '</td><td>' + chip(confClass(g(c, 'Confidence')), g(c, 'Confidence')) + '</td>';
    }, 6);
    var th = '<th scope="col" class="c-rank">#</th><th scope="col" class="c-name">Startup</th><th scope="col" class="c-num">Total raised</th><th scope="col">Last round</th><th scope="col">Status</th><th scope="col">Confidence</th>';
    wrap.replaceWith(bigTable('Startups ranked by total funding', list.length + ' startups ranked by total funding raised', th, body, list.length, 'startups'));
  }
  function enhanceDeals(block, table) {
    var hd = heads(table), ix = {}; hd.forEach(function (x, i) { ix[x] = i; });
    var g = function (c, k) { return ix[k] != null ? (c[ix[k]] || '') : ''; };
    var list = rows(table).map(cellTexts).filter(function (c) { return c.length >= 5; });
    if (!list.length) return;
    var body = tieredRows(list, null, null, function (c) {
      var st = g(c, 'Stage'), lv = stageLevel(st);
      return '<th scope="row" class="c-name"><span class="nm">' + esc(g(c, 'Company')) + '</span><span class="reg">' + esc(g(c, 'Region')) + '</span></th>' +
        '<td>' + (lv ? '<span class="nmp-stg stg-' + lv + '">' + esc(st) + '</span>' : '<span class="und">' + esc(st) + '</span>') + '</td><td class="nowrap">' + esc(shortDate(g(c, 'Date'))) + '</td>' +
        '<td class="c-num"><span class="v">' + esc(g(c, 'Deal size')) + '</span></td><td class="c-what">' + esc(g(c, 'What they do')) + '<span class="ds">' + esc(g(c, 'Category')) + '</span></td><td class="c-inv">' + esc(g(c, 'Lead investors')) + '</td>';
    }, 6);
    var th = '<th scope="col" class="c-name">Company</th><th scope="col">Stage</th><th scope="col">Date</th><th scope="col" class="c-num">Deal size</th><th scope="col">What they do</th><th scope="col">Lead investors</th>';
    block.replaceWith(bigTable('All funding deals', list.length + ' funding deals', th, body, list.length, 'deals'));
  }
  function enhanceRevenue(block, table) {
    var hd = heads(table), ix = {}; hd.forEach(function (x, i) { ix[x] = i; });
    var g = function (c, k) { return ix[k] != null ? (c[ix[k]] || '') : ''; };
    var list = rows(table).map(cellTexts).filter(function (c) { return c.length >= 6; });
    if (!list.length) return;
    var body = tieredRows(list, null, null, function (c) {
      var fr = g(c, 'Freshness'), fc = freshClass(fr), age = /(\d+)\s*mo/.exec(fr);
      var ageT = age ? (age[1] === '0' ? 'This month' : age[1] === '1' ? '1 month' : age[1] + ' months') : fr;
      var fresh = fc ? '<span class="nmp-fr ' + fc + '"><i aria-hidden="true"></i>' + esc(ageT) + '</span>' : esc(fr);
      return '<td class="c-rank">' + esc(g(c, 'Ranking')) + '</td><th scope="row" class="c-name"><span class="nm">' + esc(g(c, 'Company')) + '</span><span class="ds">' + esc(g(c, 'Segment')) + '</span></th>' +
        '<td class="c-num"><span class="v">' + esc(g(c, 'Latest Metric')) + '</span><span class="ds"><span class="nmp-tag">' + esc(g(c, 'Metric Type')) + '</span></span></td>' +
        '<td>' + fresh + '<span class="ds">' + esc(g(c, 'Disclosed When')) + '</span></td><td>' + chip(confClass(g(c, 'Confidence')), g(c, 'Confidence')) + '<span class="ds">' + esc(g(c, 'Source Quality')) + '</span></td><td class="c-what">' + esc(g(c, 'Why This Ranking')) + '</td>';
    }, 6);
    var th = '<th scope="col" class="c-rank">#</th><th scope="col" class="c-name">Company</th><th scope="col" class="c-num">Latest metric</th><th scope="col">Freshness</th><th scope="col">Confidence</th><th scope="col">Why this ranking</th>';
    block.replaceWith(bigTable('Startups ranked by revenue', list.length + ' companies ranked by latest revenue metric', th, body, list.length, 'companies'));
  }

  /* ---------- small tables ---------- */
  function wrapScroll(table) {
    if (table.parentElement && table.parentElement.classList.contains('nmp-tn')) return;
    var w = h('div', 'nmp-tn'); w.setAttribute('tabindex', '0'); w.setAttribute('role', 'region'); w.setAttribute('aria-label', 'Table');
    table.parentNode.insertBefore(w, table); w.appendChild(table);
  }
  function enhanceSmall(table) {
    var hd = heads(table), low = hd.map(function (x) { return x.toLowerCase(); });
    var trs = rows(table);
    // report contents -> checklist (35)
    if (hd.length === 2 && low[0] === 'section' && low[1].indexOf('what you get') > -1) {
      var ul = h('ul', 'nmp-ck');
      trs.forEach(function (r) { var c = r.querySelectorAll('td'); if (c.length < 2) return; ul.appendChild(h('li', '', '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg><span><b>' + esc(txt(c[0])) + '.</b> ' + c[1].innerHTML + '</span>')); });
      table.replaceWith(ul); return;
    }
    // research estimates -> one dot-plot figure (30)
    var k = low.findIndex(function (x) { return x.indexOf('estimate') > -1; });
    if (hd.length && low[0].indexOf('research') > -1 && k > 0) {
      var kw = low.findIndex(function (x, i) { return i !== 0 && i !== k; });
      var pts = trs.map(function (r) { var c = cellTexts(r); return { n: c[0], v: c[k], m: money(c[k]), w: kw > -1 ? c[kw] : '' }; }).filter(function (p) { return p.m; });
      if (pts.length >= 3) {
        var lo = Math.min.apply(null, pts.map(function (p) { return p.m; })), hi = Math.max.apply(null, pts.map(function (p) { return p.m; }));
        var step = Math.pow(10, Math.floor(Math.log10((hi - lo) || hi))), a = Math.floor(lo * 0.9 / step) * step, b = Math.ceil(hi * 1.05 / step) * step;
        var fmt = function (v) { return v >= 1e9 ? '$' + Math.round(v / 1e9) + 'B' : '$' + Math.round(v / 1e6) + 'M'; };
        var fig = h('figure', 'nmp-dp');
        fig.setAttribute('aria-label', hd[k] + ' by research group');
        fig.innerHTML = '<figcaption class="nmp-dp-cap">' + esc(hd[k]) + ' by research group</figcaption>' + pts.map(function (p) {
          return '<div class="nmp-dp-row"><span class="dp-n"><b>' + esc(p.n) + '</b><small>' + esc(p.w) + '</small></span><span class="dp-tr"><i style="left:' + (100 * (p.m - a) / (b - a)).toFixed(1) + '%"></i></span><b class="dp-v">' + esc(p.v) + '</b></div>';
        }).join('') + '<div class="nmp-dp-ax"><span></span><div><span>' + fmt(a) + '</span><span>' + fmt((a + b) / 2) + '</span><span>' + fmt(b) + '</span></div><span></span></div>';
        table.replaceWith(fig); return;
      }
    }
    // remove hand-made column widths
    table.querySelectorAll('colgroup').forEach(function (c) { c.remove(); });
    table.querySelectorAll('[width],[style]').forEach(function (e) { e.removeAttribute('width'); if (/width/.test(e.getAttribute('style') || '')) e.removeAttribute('style'); });
    // M&A tracker (32)
    var it = low.indexOf('target'), ia = low.indexOf('acquirer');
    if (it > -1 && ia > -1) {
      var iv = low.findIndex(function (x) { return x.indexOf('value') > -1; }), ist = low.findIndex(function (x) { return x.indexOf('status') > -1; }), ir = low.findIndex(function (x) { return x.indexOf('rationale') > -1; });
      var body = trs.map(function (r) {
        var c = cellTexts(r), stt = ist > -1 ? c[ist] : '', first = stt.split('.')[0], rest = stt.slice(first.length + 1).trim(), fl = first.toLowerCase();
        var badge = /completed/.test(fl) ? 'st' : /closed/.test(fl) ? 'st' : 'st st-a';
        var val = iv > -1 ? c[iv] : '', valH = /^undisclosed/i.test(val) ? '<span class="und">' + esc(val) + '</span>' : '<span class="v">' + esc(val) + '</span>';
        return '<tr><td class="nowrap">' + esc(c[0]) + '</td><td><span class="nmp-ma"><b>' + esc(c[ia]) + ' → ' + esc(c[it]) + '</b><span class="' + badge + '">' + esc(first) + '</span></span></td><td class="c-num">' + valH + '</td><td>' + esc(ir > -1 ? c[ir] : '') + '<span class="ds">' + esc(rest) + '</span></td></tr>';
      }).join('');
      table.innerHTML = '<thead><tr><th>Date</th><th>Deal</th><th class="c-num">Value</th><th>Why it matters</th></tr></thead><tbody>' + body + '</tbody>';
      wrapScroll(table); return;
    }
    // quarter tables: deltas + capital bar (25, 26)
    if (low[0] === 'quarter') {
      var vals = trs.map(function (r) { return cellTexts(r).map(function (x) { return /[$€]/.test(x) ? money(x) : (/^[\d,]+$/.test(x) ? parseFloat(x.replace(/,/g, '')) : null); }); });
      var cap = low.indexOf('capital'), cmax = cap > -1 ? Math.max.apply(null, vals.map(function (v) { return v[cap] || 0; })) : 0;
      trs.forEach(function (r, j) {
        r.querySelectorAll('td').forEach(function (td, i) {
          if (i === 0) return;
          td.classList.add('c-num'); td.innerHTML = '<span class="v">' + td.innerHTML + '</span>';
          var p = j > 0 ? vals[j - 1][i] : null, v = vals[j][i];
          if (p && v && (low[i] === 'deals' || low[i] === 'capital')) {
            var d = (v - p) / p * 100, cls = d > 0.5 ? 'up' : d < -0.5 ? 'down' : 'flat';
            td.insertAdjacentHTML('beforeend', '<span class="dlt ' + cls + '">' + (d > 0 ? '▲' : d < 0 ? '▼' : '=') + ' ' + Math.abs(d).toFixed(0) + '%</span>');
          }
          if (i === cap && v) td.insertAdjacentHTML('beforeend', bar(v, cmax));
        });
      });
      table.querySelectorAll('thead th').forEach(function (t, i) { if (i) t.classList.add('c-num'); });
    }
    // verdict chips (31)
    var vk = low.indexOf('verdict');
    if (vk > -1) trs.forEach(function (r) { var td = r.querySelectorAll('td')[vk]; if (!td) return; var v = txt(td), c = verdictClass(v); if (c) td.innerHTML = '<span class="nmp-vd ' + c + '">' + esc(v) + '</span>'; });
    // numbers on one line
    table.querySelectorAll('td').forEach(function (td) { if (/^[~≈<>]?[$€£]?[\d.,]+\s*[%BMK]?\S{0,6}$/.test(txt(td))) td.classList.add('nowrap'); });
    wrapScroll(table);
  }

  /* ---------- funding news (33, 36, 37) ---------- */
  function enhanceFundingNews() {
    art.querySelectorAll('div[style="insights"]').forEach(function (d) { d.removeAttribute('style'); d.className = 'insights'; });
    var info = {};
    var sum = art.querySelector('table.table-summary');
    if (sum) {
      var body = rows(sum).map(function (r) {
        var c = cellTexts(r); if (c.length < 5) return '';
        info[c[0].toLowerCase()] = c;
        var lv = stageLevel(c[3]);
        return '<tr><td><span class="nmp-ma"><b>' + esc(c[0]) + '</b><span>' + esc(c[4]) + '</span></span></td><td class="nowrap">' + esc(shortDate(c[1])) + '</td><td class="c-num"><span class="v">' + esc(c[2]) + '</span> ' + (lv ? '<span class="nmp-stg stg-' + lv + '">' + esc(c[3]) + '</span>' : '') + '</td></tr>';
      }).join('');
      var t = h('table', 'table-nmp', '<thead><tr><th>Startup</th><th>Date</th><th class="c-num">Amount</th></tr></thead><tbody>' + body + '</tbody>');
      sum.replaceWith(t); wrapScroll(t);
    }
    art.querySelectorAll('.cards-for-h3').forEach(function (card) {
      var h3 = card.querySelector('h3'); if (!h3) return;
      var lead = txt(h3), who = norm(lead.split(/\s+(?:raised|has raised|secured|closed|announced|completed|received|landed|disclosed|obtained|won|picked up|bagged)\b/)[0]);
      var c = info[who.toLowerCase()];
      if (!c) Object.keys(info).some(function (k) { if (who.toLowerCase().indexOf(k.split(' ')[0]) > -1) { c = info[k]; return true; } });
      var dl = '';
      card.querySelectorAll('h4').forEach(function (q) { var p = q.nextElementSibling; if (p && p.tagName === 'P') dl += '<dt>' + esc(txt(q)) + '</dt><dd>' + p.innerHTML + '</dd>'; });
      var src = card.querySelector('.sources-card');
      var lv = c ? stageLevel(c[3]) : 0;
      var a = h('article', 'nmp-dc');
      a.id = 'deal-' + who.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      a.setAttribute('data-toc', who);
      a.innerHTML = '<div class="nmp-dc-h">' + (c ? '<span class="amt">' + esc(c[2]) + '</span>' : '') + '<span class="who">' + esc(who) + '</span>' + (lv ? '<span class="nmp-stg stg-' + lv + '">' + esc(c[3]) + '</span>' : '') + (c ? '<span class="dt">' + esc(normDate(c[1])) + '</span>' : '') + '</div>' +
        '<p class="nmp-dc-lead">' + esc(lead) + '</p><dl class="nmp-dc-b">' + dl + '</dl>' + (src ? '<div class="nmp-dc-src">' + src.innerHTML + '</div>' : '');
      card.replaceWith(a);
    });
  }

  /* ---------- head: meta line (03), cover, signature (23) ---------- */
  function enhanceHead() {
    var h1 = art.querySelector('h1'), upd = art.querySelector('.last-updated');
    var date = upd ? normDate(txt(upd).replace(/Last updated:?/i, '')) : '';
    CFG.updated = date ? 'Last updated: ' + date : '';
    var words = norm(art.textContent).split(' ').length, mins = Math.max(1, Math.round(words / 230));
    var cover = art.querySelector('.img-encart img[alt^="Cover of"]'), market = '';
    if (cover) { var m = /Cover of NewMarketPitch's (.*) report/.exec(cover.getAttribute('alt') || ''); if (m) market = m[1]; cover.closest('.img-encart').classList.add('is-cover'); }
    var meta = h('p', 'nmp-meta', (market ? '<b>' + esc(market) + '</b><i aria-hidden="true"></i>' : '') + '<span>' + mins + ' min read</span>' + (date ? '<i aria-hidden="true"></i><span>Updated ' + esc(date) + '</span>' : ''));
    if (upd) upd.replaceWith(meta); else if (h1) h1.after(meta);
    art.querySelectorAll('p.summary').forEach(function (p) { if (/^\s*Download\b/.test(p.textContent)) p.remove(); });
    art.querySelectorAll('.container-summary > h2[style]').forEach(function (x) { x.removeAttribute('style'); x.classList.add('nmp-box-label'); x.textContent = x.textContent.trim().charAt(0) + x.textContent.trim().slice(1).toLowerCase(); });
    // signature: theme renders it at [[AUTHOR]]; otherwise place it after the first summary box
    var sig = art.querySelector('.nmp-sig'), tpl = document.getElementById('nmp-sig-tpl');
    if (!sig && tpl) { var first = art.querySelector('.container-summary'); if (first) first.after(tpl.content.cloneNode(true)); }
    if (!cover && !CFG.report) CFG.report = '';
  }

  /* ---------- contents sidebar (05) with sliding window ---------- */
  function buildToc() {
    if (!window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)').matches) return;
    var items = Array.prototype.slice.call(art.querySelectorAll('h2, .nmp-dc[data-toc]')).filter(function (el) { return !el.closest('.container-summary') && !el.classList.contains('nmp-box-label'); });
    if (items.length < 3) return;
    var nav = h('nav', 'nmp-toc'); nav.setAttribute('aria-label', 'In this article');
    var ol = h('ol');
    items.forEach(function (el, i) {
      var t = el.getAttribute('data-toc') || LABELS[txt(el)] || txt(el);
      if (!el.id) el.id = 'q-' + (i + 1);
      var a = h('a', '', esc(t)); a.href = '#' + el.id;
      a.addEventListener('click', function (e) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', '#' + el.id); });
      var li = h('li'); li.appendChild(a); ol.appendChild(li);
    });
    nav.innerHTML = '<div class="nmp-toc-head"><span class="nmp-toc-t">In this article</span><button type="button" class="nmp-toc-x" aria-label="Hide the contents"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
    var up = h('button', 'nmp-toc-more'), dn = h('button', 'nmp-toc-more'), win = h('div', 'nmp-toc-win');
    up.type = dn.type = 'button'; win.appendChild(ol);
    nav.appendChild(up); nav.appendChild(win); nav.appendChild(dn);
    if (CFG.report) {
      var cta = h('a', 'nmp-toc-cta', 'Get the report<i><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></i>');
      cta.href = CFG.report; nav.appendChild(cta);
    }
    var open = h('button', 'nmp-toc-open', 'Show contents'); open.type = 'button';
    document.body.appendChild(nav); document.body.appendChild(open);
    var links = Array.prototype.slice.call(ol.querySelectorAll('a'));
    function refresh() {
      var top = win.scrollTop, bot = top + win.clientHeight, above = 0, below = 0;
      links.forEach(function (l) { var y = l.offsetTop, hh = l.offsetHeight; if (y + hh <= top + 8) above++; else if (y >= bot - 8) below++; });
      up.hidden = !above; dn.hidden = !below; up.textContent = above + ' more ↑'; dn.textContent = below + ' more ↓';
      win.classList.toggle('fade-t', above > 0); win.classList.toggle('fade-b', below > 0);
    }
    win.addEventListener('scroll', refresh);
    up.addEventListener('click', function () { win.scrollBy({ top: -200, behavior: 'smooth' }); });
    dn.addEventListener('click', function () { win.scrollBy({ top: 200, behavior: 'smooth' }); });
    function setOpen(on) { document.documentElement.classList.toggle('nmp-toc-off', !on); try { localStorage.setItem('nmp-toc', on ? '1' : '0'); } catch (e) {} }
    nav.querySelector('.nmp-toc-x').addEventListener('click', function () { setOpen(false); });
    open.addEventListener('click', function () { setOpen(true); });
    try { if (localStorage.getItem('nmp-toc') === '0') document.documentElement.classList.add('nmp-toc-off'); } catch (e) {}
    function place() { var r = art.getBoundingClientRect(); nav.style.left = Math.max(16, r.left - 210 - 104) + 'px'; }
    place(); window.addEventListener('resize', place);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var idx = items.indexOf(en.target);
        links.forEach(function (l, k) { l.classList.toggle('is-on', k === idx); });
        var l = links[idx]; if (l) win.scrollTo({ top: l.offsetTop - win.clientHeight / 2 + l.offsetHeight / 2, behavior: 'smooth' });
      });
    }, { rootMargin: '-90px 0px -70% 0px' });
    items.forEach(function (el) { io.observe(el); });
    requestAnimationFrame(refresh);
  }

  /* ---------- tables taller than the screen: header follows the reader (22 Oct 2026) ----------
     All article tables, big (folded or open) and small. A floating copy of the header is pinned under the site header. */
  function stickyHeads() {
    var list = [];
    function add(box, sc, small) {
      var tb = sc && sc.querySelector('table'), th = tb && tb.querySelector('thead');
      if (!th || !th.querySelector('th')) return;
      var fl = h('div', 'nmp-bt-float' + (small ? ' nmp-tn-float nmp-art' : '')); fl.setAttribute('aria-hidden', 'true');
      var ct = h('table', small ? 'table-nmp' : 'nmp-bt-table'); ct.appendChild(th.cloneNode(true)); fl.appendChild(ct);
      document.body.appendChild(fl);
      var it = { box: box, sc: sc, tb: tb, th: th, fl: fl, ct: ct, pins: ct.querySelectorAll('.c-rank, .c-name'), on: false };
      sc.addEventListener('scroll', function () { if (it.on) shift(it); }, { passive: true });
      list.push(it);
    }
    art.querySelectorAll('.nmp-bt').forEach(function (box) { add(box, box.querySelector('.nmp-bt-scroll'), false); });
    art.querySelectorAll('.nmp-tn').forEach(function (w) { if (w.querySelector('table.table-nmp')) add(w, w, true); });
    if (!list.length) return;
    function topLine() {
      var hd = document.querySelector('sticky-header, .section-header');
      if (!hd) return 0;
      var b = hd.getBoundingClientRect().bottom;
      return b > 0 && b < window.innerHeight / 2 ? b : 0;
    }
    function shift(it) {
      var x = it.sc.scrollLeft;
      it.ct.style.transform = 'translateX(' + (-x) + 'px)';
      it.pins.forEach(function (p) { p.style.transform = 'translateX(' + x + 'px)'; });
    }
    function size(it) {
      var src = it.th.querySelectorAll('th'), dst = it.ct.querySelectorAll('th');
      it.ct.style.setProperty('width', it.tb.offsetWidth + 'px', 'important');
      src.forEach(function (s, i) {
        if (!dst[i]) return;
        var w = s.getBoundingClientRect().width + 'px';
        ['width', 'min-width', 'max-width'].forEach(function (p) { dst[i].style.setProperty(p, w, 'important'); });
      });
    }
    var queued = false;
    function update() {
      queued = false;
      var line = topLine(), vh = window.innerHeight;
      var st = list.map(function (it) {
        var r = it.sc.getBoundingClientRect(), hh = it.th.offsetHeight;
        return { on: it.tb.offsetHeight > vh * 1.1 && r.top < line && r.bottom > line + hh * 2, r: r, w: it.sc.clientWidth };
      });
      list.forEach(function (it, i) {
        var s = st[i];
        if (s.on) {
          if (!it.on) size(it);
          it.fl.style.top = line + 'px'; it.fl.style.left = s.r.left + 'px'; it.fl.style.width = s.w + 'px';
          shift(it);
        }
        it.on = s.on; it.fl.classList.toggle('is-on', s.on);
      });
    }
    function ask() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    var settle;
    window.addEventListener('scroll', function () { ask(); clearTimeout(settle); settle = setTimeout(ask, 260); }, { passive: true });
    window.addEventListener('resize', function () { list.forEach(function (it) { it.on = false; }); ask(); });
    art.addEventListener('click', function () { setTimeout(ask, 50); });
    art.addEventListener('input', ask);
  }

  /* ---------- run ---------- */
  enhanceHead();
  art.querySelectorAll('.db-wrap').forEach(function (w) {
    var t = w.querySelector('table'); if (!t) return;
    if (t.classList.contains('vdb')) enhanceValuation(w, t); else if (t.classList.contains('db')) enhanceTopFunding(w, t);
  });
  art.querySelectorAll('.nmp-fund').forEach(function (b) { var t = b.querySelector('table'); if (t) enhanceDeals(b, t); });
  art.querySelectorAll('.nmp-rev').forEach(function (b) { var t = b.querySelector('table'); if (t) enhanceRevenue(b, t); });
  enhanceFundingNews();
  art.querySelectorAll('table.table-nmp').forEach(enhanceSmall);
  stickyHeads();
  art.classList.add('is-enhanced');
  buildToc();
})();
